import { MatSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectionStrategy, Component, inject, model, signal, ViewChild } from '@angular/core';
import { TitleComponent } from "../../shared/components/title-component/title-component";
import { SearchBarComponent } from '../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { UpperCasePipe, NgIf } from '@angular/common';
import { Compagnie } from '../../shared/model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { CompagnieService } from '../service/compagnie-service';
import { ToastrService } from '../../shared/services/toastr-service';
import { SweetAlertService } from '../../shared/services/sweet-alert-service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { DatabaseConnection } from '../../shared/services/database-connection';

export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Compagnie
}

@Component({
  selector: 'app-compagnie-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatAnchor,
    MatIconModule,
    MatTooltip,
    MatButtonModule,
    UpperCasePipe,
    MatSpinner
  ],
  templateUrl: './compagnie-component.html',
  styleUrl: './compagnie-component.css',
})
export class CompagnieComponent {
  displayedColumns: string[] = ['id', 'logo', 'name', 'code', 'status', 'adresse', 'actions'];
  dataSource!: MatTableDataSource<Compagnie>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  currentCompagnie = signal<Compagnie>(new Compagnie())
  readonly dialog = inject(MatDialog);
  API_STORAGE = inject(DatabaseConnection).storageConnection.value

  loading = false

  constructor(
    private compagnieService : CompagnieService,
    private toastr : ToastrService,
    private sweetAlert : SweetAlertService){
    // Assign the data to the data source for the table to render
    this.dataSource = new MatTableDataSource<Compagnie>([]);
  }

  ngOnInit(): void {
    this.loading = true
    this.compagnieService.getAll().subscribe({
      next : (res) =>{
        console.log(res);
        this.dataSource.data = res
        this.loading = false
      },
      error : (err) =>{
        this.loading = false
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  openAddCollaborateurModal(){
    const data : ModalDataI = {
      title : 'Ajouter une compagnie',
      data : new Compagnie()
    }

    const dialogRef = this.dialog.open(CompagnieComponentModal, {
      width : '1000px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Compagnie) => {

      if (result?.id != undefined) {
        const data : Compagnie[] = []
        data.push(...this.dataSource.data)
        data.push(result)

        this.dataSource.data = data
        this.toastr.success("La compagnie "+ result.name + " à été ajouté")
      }
    });
  }

  openUpdate(compagnie : Compagnie){
    this.currentCompagnie.set(compagnie)

    const data : ModalDataI = {
      title : 'Modifier la compagnie ' + compagnie.name,
      update : true,
      data : this.currentCompagnie()
    }

    const dialogRef = this.dialog.open(CompagnieComponentModal, {
      width : '1000px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Compagnie) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("La compagnie "+ result.name + " à été modifie")
      }
    });
  }

  confirm(compagnie : Compagnie){
    this.sweetAlert
    .confirm('Etez-vous sur de vouloir supprimer la compagnie '+ compagnie.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.compagnieService.delete(compagnie.id).subscribe({
          next : (r) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != compagnie.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

  onChange(compagnie : Compagnie){
    const title = compagnie.disable?'Activation':'Desactivation'
    const action = compagnie.disable?'activer':'desactiver'
    this.sweetAlert.confirm('Etez-vous sur de vouloir ' + action + ' la compagne '+compagnie.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.compagnieService.changeStatus(compagnie.id).subscribe({
          next : (result) =>{
            const i = this.dataSource.data.findIndex(item => item.id == result.id)
            const data = this.dataSource.data
            data[i] = result
            this.dataSource.data = data
            this.sweetAlert.success('Operaton reussie', 2000)
          }
        })
      }
    })
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}

@Component({
  selector: 'app-compagnie-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    NgIf,
    MatTooltip,
    MatSelectModule,
    MatIcon
  ],
  templateUrl: './modal-compagnie.html',
  styleUrl: './modal-compagnie.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompagnieComponentModal {
  readonly dialogRef = inject(MatDialogRef<CompagnieComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  // retourne le donne vers le parent
  readonly collaborateur = model(this.inputData.data!);

  compagnieForm : FormGroup = new FormGroup({})
  fileName = '';
  selectedFile: File | null = null;

  constructor(
    private fb : FormBuilder,
    private compagnieService : CompagnieService,
    private toastr : ToastrService
  ){

  }

  ngOnInit(): void {
    this.compagnieForm = this.fb.group({
      name : ['', [Validators.required]],
      code : ['', [Validators.required]],
      logo : ['', [Validators.required]],
      forme : ['', [Validators.required]],
      capital : ['', [Validators.required]],
      niu : ['', [Validators.required]],
      rccm : ['', [Validators.required]],
      agrement : ['', [Validators.required]],
      adresse : ['', [Validators.required]],
      bp : ['', [Validators.required]],
      tel : ['', [Validators.required]],
      email : ['', [Validators.required, Validators.email]],
    })
  }

  ngAfterViewInit(): void {
    this.compagnieForm.patchValue(this.inputData?.data!)
  }

  resetForm(){
    this.compagnieForm.patchValue({
      name : '',
      code : '',
      logo : '',
      description : ''
    })
    this.selectedFile = null
    this.fileName = ''
  }


  onFileSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    const files: FileList | null = element.files;
    if (files && files.length > 0) {

      console.log(files[0]);

      this.selectedFile = files[0];
      this.fileName = this.selectedFile.name;
      this.compagnieForm.get('logo')?.setValue(this.selectedFile.name)
      // You can now proceed to upload the file using HttpClient
    } else {
      this.fileName = '';
      this.selectedFile = null;
    }
  }

  onAdd(){
    const data = new FormData();
    data.append('name' , this.compagnieForm.get('name')?.value)
    data.append('code' , this.compagnieForm.get('code')?.value)
    data.append('forme' , this.compagnieForm.get('forme')?.value)
    data.append('capital' , this.compagnieForm.get('capital')?.value)
    data.append('bp' , this.compagnieForm.get('bp')?.value)
    data.append('adresse' , this.compagnieForm.get('adresse')?.value)
    data.append('niu' , this.compagnieForm.get('niu')?.value)
    data.append('rccm' , this.compagnieForm.get('rccm')?.value)
    data.append('agrement' , this.compagnieForm.get('agrement')?.value)
    data.append('email' , this.compagnieForm.get('email')?.value)
    data.append('tel' , this.compagnieForm.get('tel')?.value)
    data.append('logo', (this.selectedFile as Blob), this.selectedFile?.name)

    this.compagnieService.create(data).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

  onUpdate(){

    const data = new FormData();
    data.append('name' , this.compagnieForm.get('name')?.value)
    data.append('code' , this.compagnieForm.get('code')?.value)
    data.append('forme' , this.compagnieForm.get('forme')?.value)
    data.append('capital' , this.compagnieForm.get('capital')?.value)
    data.append('bp' , this.compagnieForm.get('bp')?.value)
    data.append('adresse' , this.compagnieForm.get('adresse')?.value)
    data.append('niu' , this.compagnieForm.get('niu')?.value)
    data.append('rccm' , this.compagnieForm.get('rccm')?.value)
    data.append('agrement' , this.compagnieForm.get('agrement')?.value)
    data.append('email' , this.compagnieForm.get('email')?.value)
    data.append('tel' , this.compagnieForm.get('tel')?.value)
    data.append('_method', 'PUT')

    if(this.selectedFile != null)
      data.append('logo', (this.selectedFile as Blob), this.selectedFile?.name)

    this.compagnieService.update(data, this.inputData.data?.id??'').subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }


}
